import { ShareTarget } from '../../services/sharing/ShareTarget'

export function SessionShare({ sessionId }: { sessionId: string }) {
  return <ShareTarget documentId={sessionId} kind="session" />
}
